





















































































import { changeLoading } from '@/util/plugins';
const dateFormat = require('bmh/date-format');
const getUrl = require('baimahu/url-with-param');
import { Component, Vue } from 'vue-property-decorator';
const { VUE_APP_API, VUE_APP_FCAPI: FCAPI } = process.env;
import { Moment } from 'moment';
const API = {
  getlist: `${FCAPI}/shang/ruan/order/sign`,
};
const status = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '下订',
  },
  {
    value: 2,
    label: '签约',
  },
  {
    value: 3,
    label: '退单',
  },
];
interface Form {
  city: string;
  user: string;
  signed_time: Moment[];
  signed_brand: string;
}
function initForm() {
  return {
    city: '',
    user: '',
    signed_time: [],
    signed_brand: '',
  };
}
interface Table<T> {
  limit: number;
  total: number;
  detail: T[];
  current: number;
  last: number;
}
function getData(remote?: Table<any>) {
  remote = (remote || {}) as Table<any>;
  return {
    total: remote.total || 0,
    limit: remote.limit || 1,
    current: remote.current || 1,
    data: remote.detail || [],
    last: remote.last || 1,
    detail: remote.detail || [],
  };
}
@Component
export default class SignedUser extends Vue {
  is_loading: boolean = false;
  show_modal: boolean = false;
  form: Form = initForm();
  table_data: Table<any> = getData();
  get status() {
    return status;
  }
  changePage(page: any) {
    this.search(page.current);
  }

  @changeLoading(['is_loading'])
  async search(page: number = 1) {
    const start_time = this.form.signed_time[0]
      ? Math.floor((this.form.signed_time[0] as any).hours(0).minutes(0).seconds(0) / 1000)
      : '';
    const end_time = this.form.signed_time[1]
      ? Math.floor((this.form.signed_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1
      : '';
    const send_data = {
      current: page,
      limit: 50,
      city: this.form.city ? this.form.city : '',
      brand: this.form.signed_brand ? this.form.signed_brand : '',
      name_or_mobile: this.form.user ? this.form.user : '',
      create_start_time: start_time,
      create_end_time: end_time,
    };
    const url = getUrl(API.getlist, send_data);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
    }
    res.data.data.detail.forEach((item: any) => {
      item.brand_json = JSON.parse(item.brand_json);
    });
    this.table_data = getData(res.data.data);
  }
  formatMobile(phone: any) {
    phone = '' + phone;
    const tel = phone.substr(0, 3) + '****' + phone.substr(7);
    return tel;
  }
  formatID(id: any) {
    const format_str = '00000000';
    id = '' + id;
    return `R${format_str.substr(0, 8 - id.length)}${id}`;
  }
  formatDeposit(id: any) {
    const format_str = '00000000';
    id = '' + id;
    return `D${format_str.substr(0, 8 - id.length)}${id}`;
  }
  paginationOption(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }
  clearForm() {
    this.form = initForm();
  }
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }
  created() {
    this.search(1);
  }
}
